import React__default from 'react';
import { InfoIconCore } from '../shared/components/InfoIcon.mjs';
import { Tooltip } from './Tooltip.mjs';

const InfoIcon = (props)=>{
    return /*#__PURE__*/ React__default.createElement(InfoIconCore, {
        ...props,
        TooltipComponent: Tooltip
    });
};

export { InfoIcon };
//# sourceMappingURL=InfoIcon.mjs.map
